import { constants } from "../../../constants";

export default class LobbyLoadEnd {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.lobbyLoadEnd();
    }

    exposeEvent() {
        let event = {};
        switch (this.gb.gameProviderProtocol) {
            case constants.EVOLUTION:
                event["LOBBY_CATEGORY_LOADED"] = this._default;
                break;
            case constants.EDIG:
                event["openLobby"] = this._default;
                break;

            default:
                event["logoutToLobby"] = this._default;
        }

        return event;
    }
}
